import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, HttpModule, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { configURI } from '../../../shared/apiUrlConfig';
import { Region } from '../../model/region.model';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class RegionService {
  url = environment.configURI;

  // httpHeaderOptions = {
  //   headers: new Headers({
  //     'x-access-token': localStorage.getItem('Token'),
  //     'Cache-Control': 'no-cache',
  //     'Pragma': 'no-cache',
  //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
  //   })
  // };

  constructor(private http: Http,  public httpClient: HttpClient,
              public userFriendlyMsgs: UserFriendlyMsgs) { }

  regionGet(region: Region) {
    // this.httpHeaderOptions = {
    //   headers: new Headers({
    //     'x-access-token': localStorage.getItem('Token'),
    //     'Cache-Control': 'no-cache',
    //     'Pragma': 'no-cache',
    //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    //   })
    // };
    //this.httpHeaderOptions.headers.set('x-access-token', localStorage.getItem('Token'));
    // return this.http.get(this.url + '/region/getregion', )
    return this.httpClient.get(this.url + '/region').catch(this.userFriendlyMsgs.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/region/region.service.ts